import React, { useEffect, useState,useRef } from "react";
import { useMountEffect } from 'primereact/hooks';
import { Messages } from 'primereact/messages';
import GetRequest from "../../../../service/GetRequest";
import { toast, ToastContainer } from 'react-toastify';
import BranchListTable from "../../../../components/Tables/BranchListTable";
import { Tag } from 'primereact/tag';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import '../../StoreDashboard/style.css'
import CookieHandler from '../../../LandingPage/Authentication/CookieHandler'

const ViewMyStorePage = ({setActivePath}) => {
    const userId = CookieHandler.getCookie("userid");

    const [branchId,setBranchId ] = useState("");
    const [brandName,setBrandName ] = useState("");
    const [tagline,setTagline ] = useState("");
    const [description,setDescription ] = useState("");
    const [bussinessType,setBussinessType ] = useState("");
    const [theme,setTheme ] = useState("#000000");
    const [font,setFont ] = useState("");
    const [isDarkMode, setIsDarkMode] = useState(); // State to hold checkbox value
    const [Image, setImage] = useState(null);
    const [createdDate, setCreatedDate] = useState("");
    const [modifiedDate, setModifiedDate] = useState("");
    const [subscription, setSubscription] = useState("Basic");
    // const [settings, setSettings] = useState();
    // const [deployment, setDeployment] = useState([]);
    // const [branches, setBranches] = useState([]);

    const msgs = useRef(null);
    
    useMountEffect(() => {
        if (msgs.current) {
            msgs.current.clear();
            msgs.current.show([
                { sticky: true, severity: 'warn', summary: 'Warning', detail: 'Your free trail is about to end, please Upgrade to prevent lossing your data' },
            ]);
        }
    });


    useEffect(() => {
        setActivePath("Your Store");
    
        GetRequest("v1/store-management-service/view/my/store",true)
            .then(response => {
                if (!response || response === undefined) {
                    console.log("No store found for this user");
                } else {
                    console.log(response);
                    setBranchId(response.id)
                    setBrandName(response.brandName);
                    setTagline(response.tagline);
                    setDescription(response.brandDescription);
                    setBussinessType(response.businessType);
                    setTheme(response.brandTheme);
                    setFont(response.brandFont);
                    setIsDarkMode(response.darkModeEnabled);
                    setImage(response.brandLogo);
                    setCreatedDate(response.createdDate);
                    setModifiedDate(response.lastUpdatedDate);
                    // setSettings();
                    // setDeployment();
                    // setBranches();
                    setSubscription(response.subscription);
                }
            })
            .catch(error => {
                console.error("Error fetching store data:", error);
                // Handle error appropriately, such as displaying a toast
                toast.error("An error occurred while fetching store data. Please try again later.");
            });
    }, [ userId, setActivePath]);


  return (
    <div className="outlet-container">
        <div className="page-container">
        <Messages ref={msgs} />

            <div className="card view-my-store-header-blocks">
                <div className="store-info-block">
                    <div className="store-logo-image-container">{Image}</div>
                    <div className="store-quick-info-container">
                        <Tag severity="warning" value="Upgrade package" rounded></Tag>
                        <div className="store-title">{brandName}</div>
                        <div className="store-tagline">{tagline}</div>
                        <div className="store-bussiness-type">{bussinessType}</div>
                        <div className="store-created-date">Created on : {createdDate}</div>
                        <div className="store-created-date">
                            <div>Current Plan :</div>             <Tag value={subscription ? subscription : "Basic"} rounded></Tag>
                            <Button label="Upgrade now" severity="success" outlined />                        
                        <div></div>
                        </div>
                    </div>
                </div>
                <Divider layout="vertical" />

                <div className="store-rating-block">
                <Button label="preview" severity="success" outlined />                        
            </div> </div>
            <div className='blocks-with-two-subsections'>
                <div className="card first-block-large"><br/>
                    <div className="brand-description-title">Description</div>
                    <div className="brand-description-content">{description}</div>
                </div>
                <div className="card second-block">
                    <div className="theme-info-text">Font : {font}</div>
                    <div className="theme-box">
                        <div className="theme-info-text">Your Bussiness Theme color</div>
                        <div className="store-theme-info" style={{ width: '50px', height: '50px', backgroundColor: theme }}></div>
                    </div>
                    <div className="theme-box">
                        <div className="theme-info-text">Dark Mode</div>
                        <label className="switch">
                            <input type="checkbox" value={isDarkMode} disabled />
                            <span className="slider"></span>
                        </label>
                    </div>
                  
    
                        
                    </div>
            </div>
            <BranchListTable/>
        </div>
        <ToastContainer closeButton={false}/>

    </div>
  )
}

export default ViewMyStorePage
